<template>
  <div class="auth-layout min-h-screen">
    <FLoader />
    <router-view />
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>
<script>

export default {
  name: 'AuthLayout',
  components: {

  },

  data() {
    return {
  
    };
  },

  computed: {

  },
  watch: {
    '$route'() {
      window.scrollTo(0, 0);
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>